import { useEffect, useState } from "react";
import { getPropertyTypeList } from "utils/api/lookupApi";
import { OptionRenderType } from "controls/global/stewart-checkbox/StewartAutocompleteWithCheckboxes";

// Property-type dropdown options sourced from /lookup/GetPIList/PropertyType.
// Label = PropertyTypeName, value = PropertyTypeCode.
export function usePropertyTypeOptions(): OptionRenderType[] {
  const [options, setOptions] = useState<OptionRenderType[]>([]);
  useEffect(() => {
    let mounted = true;
    getPropertyTypeList().then((rows) => {
      if (!mounted) return;
      setOptions(
        rows.map((r) => ({ label: r.PropertyTypeName, value: r.PropertyTypeCode }))
      );
    });
    return () => {
      mounted = false;
    };
  }, []);
  return options;
}
